import React from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarIcon } from "lucide-react";
import { format, parseISO } from "date-fns";

/**
 * Date picker storing & emitting an ISO date string (yyyy-MM-dd).
 */
export default function DatePickerField({ value, onChange, placeholder = "Pick a date", testId = "date" }) {
  const date = value ? parseISO(value) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`${testId}-trigger`}
          className="w-full h-10 border vsm-border vsm-surface px-3 text-sm flex items-center justify-between gap-2 rounded-none"
        >
          <span className={value ? "" : "vsm-muted"}>
            {value ? format(date, "PPP") : placeholder}
          </span>
          <CalendarIcon className="w-4 h-4 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="rounded-none p-0 border vsm-border vsm-surface w-auto"
        data-testid={`${testId}-popover`}
      >
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
          initialFocus
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            data-testid={`${testId}-clear`}
            className="w-full text-xs uppercase tracking-wider py-2 border-t vsm-border vsm-muted hover:vsm-fg"
          >
            Clear
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
}
